import { Skeleton } from "@/atoms"
import { useRef } from "react"
import { IntegrationCardTemplate } from "../../templates/IntegrationCardTemplate"

import type { ListIntegrationsSkeletonProps } from "."

export const ListIntegrationsSkeleton = (
  props: ListIntegrationsSkeletonProps
) => {
  const listSkeleton = useRef(Array(10).fill(0)).current

  return (
    <>
      {listSkeleton.map((_, index) => {
        if (props.menu)
          return (
            <Skeleton.Button
              active
              key={index}
              size="default"
              style={{ width: "100%" }}
            />
          )

        return (
          <IntegrationCardTemplate
            key={index}
            header={
              <Skeleton.Node active>
                <div />
              </Skeleton.Node>
            }
            title={<Skeleton active paragraph={{ rows: 2 }} />}
            tags={<Skeleton active paragraph={{ rows: 0 }} />}
          />
        )
      })}
    </>
  )
}
